// src/components/Content.js
import React from "react";
import styles from "./blogContent.module.css";

export const BlogContent = (props) => {
  const { title, subtitle, image, sections, footer } = props;
  console.log(image);
  
  return (
    <article className={styles.content}>
      <header className={styles.contentHeader}>
        <h1 className={styles.contentTitle}>{title}</h1>
        {subtitle && <p className={styles.contentSubtitle}>{subtitle}</p>}
      </header>

      {image && (
        <div className={styles.contentImageWrapper}>
          <img 
            src={require(`../assets/education/${image}`).default}
            alt={title} className={styles.contentImage} 
          />
          
        </div>
      )}

      {sections && (
        <section className={styles.contentBody}>
        {sections.map((section, idx) => (
          <div key={idx} className={styles.contentSection}>
            {section.heading && (
              <h2 className={styles.contentSectionHeading}>{section.heading}</h2>
            )}
            <p className={styles.contentSectionText}>{section.text}</p>
          </div>
        ))}
      </section>
      )}

      {footer && <footer className={styles.contentFooter}>{footer}</footer>}
    </article>
  );
};

export default BlogContent;

